import React, { createContext, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { logger } from './logger';
import { request } from './request';

export interface IUser {
  jwt: string;
}

let authContext: React.Context<{
  user: IUser | undefined;
  login: (data: any) => Promise<void>;
  logout: () => void;
  signUp: (data: any) => Promise<void>;
}>;

let interceptorsAdded = false;

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const auth = useProvideAuth();

  if (!authContext) {
    authContext = createContext(auth);
  }

  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
  return useContext(authContext);
};

function useProvideAuth() {
  const [user, setUser] = useState<IUser | undefined>(getLocalStorageUser());
  const history = useHistory();

  const login = async (data: any) => {
    const response = await request.post('/auth/login', data);
    const user = {
      jwt: response.data.access_token
    };

    localStorage.setItem('user', JSON.stringify(user));
    setUser(user)
  };

  const logout = () => {
    localStorage.clear();
    setUser(undefined);
  }

  const signUp = async (data: any) => {
    await request.post('/users', data);
  };

  if (!interceptorsAdded) {
    request.interceptors.request.use(config => {

      config.headers = {
        ...(config.headers || {}),
        'Authorization': `Bearer ${getLocalStorageUser()?.jwt}`
      }

      return config;
    });

    request.interceptors.response.use(
      undefined,
      error => {
        if (error?.response?.status === 401) {
          logout();
          history.push('/login');
          logger.info('redirected to login page');
        }

        throw error;
      }
    )

    interceptorsAdded = true;
    logger.info('auth interceptors added');
  }

  return {
    user,
    login,
    logout,
    signUp
  };
}

function getLocalStorageUser(): IUser {
  const storageItem = localStorage.getItem('user');
  return (storageItem && JSON.parse(storageItem)) || undefined;
}